import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const Body = styled.div`
  padding: ${theme('spaces.1')} ${theme('spaces.2')};
`

export default Body
